import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import goldTrophy from 'assets/images/trophy-gold.png';
import silverTrophy from 'assets/images/trophy-silver.png';
import bronzeTrophy from 'assets/images/trophy-bronze.png';
import { PrizePlaceFormat } from 'shared/components/Format/PrizePlaceFormat';
import { useStyles } from './Place.styles';

interface PrizeProps {
  places: number[];
}

export const Place: FC<PrizeProps> = ({ places = [] }) => {
  const { classes } = useStyles();

  const trophyConfig: Record<number, JSX.Element> = {
    1: <img src={goldTrophy} className={classes.trophy} alt="Gold Trophy" />,
    2: <img src={silverTrophy} className={classes.trophy} alt="Silver Trophy" />,
    3: <img src={bronzeTrophy} className={classes.trophy} alt="Bronze Trophy" />,
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.trophyContainer}>{trophyConfig[places[0]]}</Box>
      <Typography>
        <PrizePlaceFormat places={places} />
      </Typography>
    </Box>
  );
};
